var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvergreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 367,
    height: 130,
    viewBox: "0 0 367 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24828 3793)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 367,
    height: 130,
    transform: "translate(-24828 -3793)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25213.328 -4227.815)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 15.886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.725,463.818l13.658,40.6,7.075,0,7.075,0,13.658-40.6-13.713-.005-7.02,27.347-7.021-27.347Z",
    fill: "#00933e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.4,494.708H398.981v-7.347H421.4v-7.912H398.981v-6.217H421.4v-9.419H385.983v40.315H421.4Z",
    fill: "#00933e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.934,494.708H484.515v-7.347h22.419v-7.912H484.515v-6.217h22.419v-9.419H471.518v40.315h35.416Z",
    fill: "#00933e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.759,494.708H647.342v-7.347h22.417v-7.912H647.342v-6.217h22.417v-9.419H634.342v40.315h35.417Z",
    fill: "#00933e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.5,494.708H687.083v-7.347H709.5v-7.912H687.083v-6.217H709.5v-9.419H674.084v40.315H709.5Z",
    fill: "#00933e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.825,463.815h-13v40.313h13V483.07L739,504.128h13V463.815H739v20.727Z",
    fill: "#00933e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.9,489.946v14.183H511.26V463.814h31.432a4.918,4.918,0,0,1,4.9,4.9v13.846a2.935,2.935,0,0,1-2.927,2.927h.093a2.843,2.843,0,0,1,2.834,2.834v15.587a.219.219,0,0,1-.219.218h-11.9a.219.219,0,0,1-.219-.218V493.519a3.582,3.582,0,0,0-3.571-3.571H523.9Zm0-16.36h9.529a1.749,1.749,0,0,1,1.744,1.744V479.4a1.749,1.749,0,0,1-1.744,1.744H523.9v-7.561Z",
    fill: "#00933e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.824,463.813h27.628a4.918,4.918,0,0,1,4.9,4.9v7.467H576.994v-.806a1.981,1.981,0,0,0-1.974-1.974h-8.876a1.98,1.98,0,0,0-1.974,1.974v17.188a1.979,1.979,0,0,0,1.974,1.974h8.876a1.98,1.98,0,0,0,1.974-1.974v-3.418h-7.328v-8.172h19.689v18.251a4.918,4.918,0,0,1-4.9,4.9H556.824a4.918,4.918,0,0,1-4.9-4.9V468.718a4.919,4.919,0,0,1,4.9-4.9Z",
    fill: "#00933e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.324,489.946v14.183H593.681V463.814h31.432a4.918,4.918,0,0,1,4.9,4.9v13.846a2.935,2.935,0,0,1-2.927,2.927h.093a2.843,2.843,0,0,1,2.834,2.834v15.587a.219.219,0,0,1-.219.218h-11.9a.219.219,0,0,1-.219-.218V493.519a3.582,3.582,0,0,0-3.571-3.571h-7.78Zm0-16.36h9.529a1.749,1.749,0,0,1,1.744,1.744V479.4a1.749,1.749,0,0,1-1.744,1.744h-9.529v-7.561Z",
    fill: "#00933e",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvergreen);
export default __webpack_public_path__ + "static/media/evergreen.d44bf58fd4cafd36c5227c6311b29989.svg";
export { ForwardRef as ReactComponent };